export function calculateFinalPrice(stock_price: string|number, gst: number, margin: number) {
  const cleanStockPrice =
      typeof stock_price === "string"
          ? parseFloat(stock_price.replace(/,/g, ""))
          : stock_price || 0;
  const gstAmount = cleanStockPrice * ((gst || 0) / 100);
  const priceWithGst = cleanStockPrice + gstAmount;
  const finalPrice = priceWithGst * (1 + (margin || 0) / 100);
  return finalPrice.toFixed(2);
}
